// Instance form for the guided setup in the CI/CD import (CicdSetup section 4).
// Deliberately uses the same iio building blocks and field layout as the instance
// form in SpaceDetail (connection tab, including the service key paste), but
// tailored to the import case: connection fields come pre-filled from the GitHub
// environment, only the secrets are missing (write-only on GitHub's side) and are
// mandatory here.
// SpaceDetail stays untouched; converging the two forms is noted as a follow-up
// task in the project notes.
export default function CicdImportInstanceForm({ form, setField, env, addToast }) {
  const pre = (key) => (form._prefilled && form._prefilled[key] ? " cs-prefill" : "");
  const hint = (key) => form._prefilled && form._prefilled[key] && <div className="iio-field-hint cs-prefill-hint">Aus GitHub-Environment {env.env} übernommen</div>;

  return (
    <div className="cs-instform">
      <div className="iio-field">
        <span className="iio-field-label">Service Key einfügen (optional)</span>
        <textarea
          className="iio-textarea cs-paste"
          placeholder={'JSON-Body des BTP Service Keys hier einfügen - füllt die Felder inkl. Secret automatisch'}
          onPaste={(e) => {
            const text = e.clipboardData.getData("text");
            try {
              const parsed = JSON.parse(text);
              const o = parsed.oauth || parsed;
              if (o.url) setField("tenantUrl", String(o.url).replace(/\/+$/, ""));
              if (o.clientid || o.clientId) setField("clientId", o.clientid || o.clientId);
              if (o.clientsecret || o.clientSecret) setField("clientSecret", o.clientsecret || o.clientSecret);
              if (o.tokenurl || o.tokenUrl) setField("tokenUrl", o.tokenurl || o.tokenUrl);
              setField("authType", "oauth");
              addToast("Service Key importiert - Verbindungsdaten befüllt", "success");
              e.preventDefault();
            } catch {
              addToast("JSON konnte nicht gelesen werden - bitte prüfe das Format", "error");
            }
          }}
        />
      </div>

      <div className="iio-field">
        <label className="iio-field-label" htmlFor="cs-inst-name">Anzeigename</label>
        <input id="cs-inst-name" className={"iio-input" + pre("name")} value={form.name} onChange={(e) => setField("name", e.target.value)} placeholder="z. B. Integration QAS"/>
      </div>

      <div className="iio-field">
        <label className="iio-field-label" htmlFor="cs-inst-desc">Beschreibung</label>
        <textarea id="cs-inst-desc" className="iio-textarea" value={form.description} onChange={(e) => setField("description", e.target.value)} placeholder="Wofür ist diese Instanz? Welche Prozesse laufen darüber?"/>
        <div className="iio-field-hint">Optional. Hilft Kollegen, den Kontext schnell zu erfassen.</div>
      </div>

      <div className="iio-field">
        <span className="iio-field-label">Authentifizierung</span>
        <div className="iio-auth-toggle">
          <button type="button" className={form.authType === "oauth" ? "is-active" : ""} onClick={() => setField("authType", "oauth")}>OAuth 2.0</button>
          <button type="button" className={form.authType === "basic" ? "is-active" : ""} onClick={() => setField("authType", "basic")}>Basic Auth</button>
        </div>
        {hint("authType")}
      </div>

      <div className="iio-field">
        <label className="iio-field-label">Tenant URL</label>
        <input className={"iio-input iio-input--mono" + pre("tenantUrl")} value={form.tenantUrl} onChange={(e) => setField("tenantUrl", e.target.value)} placeholder="https://*.cfapps.eu10.hana.ondemand.com"/>
        {hint("tenantUrl")}
      </div>

      {form.authType === "oauth" ? (
        <>
          <div className="iio-field">
            <label className="iio-field-label">Token URL</label>
            <input className={"iio-input iio-input--mono" + pre("tokenUrl")} value={form.tokenUrl} onChange={(e) => setField("tokenUrl", e.target.value)} placeholder="https://*.authentication.eu10..."/>
            {hint("tokenUrl")}
          </div>
          <div className="iio-fields-2">
            <div className="iio-field">
              <label className="iio-field-label">Client ID</label>
              <input className={"iio-input iio-input--mono" + pre("clientId")} value={form.clientId} onChange={(e) => setField("clientId", e.target.value)}/>
              {hint("clientId")}
            </div>
            <div className="iio-field">
              <label className="iio-field-label">Client Secret <span className="cs-req">Pflichtfeld</span></label>
              <input className="iio-input iio-input--mono" type="password" value={form.clientSecret} onChange={(e) => setField("clientSecret", e.target.value)} placeholder="aus dem BTP Service Key"/>
              <div className="iio-field-hint">GitHub-Secrets sind write-only und können nicht ausgelesen werden - bitte hier eintragen.</div>
            </div>
          </div>
        </>
      ) : (
        <div className="iio-fields-2">
          <div className="iio-field">
            <label className="iio-field-label">Benutzername</label>
            <input className={"iio-input iio-input--mono" + pre("username")} value={form.username} onChange={(e) => setField("username", e.target.value)}/>
            {hint("username")}
          </div>
          <div className="iio-field">
            <label className="iio-field-label">Passwort <span className="cs-req">Pflichtfeld</span></label>
            <input className="iio-input iio-input--mono" type="password" value={form.password} onChange={(e) => setField("password", e.target.value)}/>
            <div className="iio-field-hint">GitHub-Secrets sind write-only und können nicht ausgelesen werden - bitte hier eintragen.</div>
          </div>
        </div>
      )}

      {form.policyUsername ? (
        <div className="iio-fields-2">
          <div className="iio-field">
            <label className="iio-field-label">Policy-Benutzer</label>
            <input className={"iio-input iio-input--mono" + pre("policyUsername")} value={form.policyUsername} onChange={(e) => setField("policyUsername", e.target.value)}/>
            {hint("policyUsername")}
          </div>
          <div className="iio-field">
            <label className="iio-field-label">Policy-Passwort</label>
            <input className="iio-input iio-input--mono" type="password" value={form.policyPassword} onChange={(e) => setField("policyPassword", e.target.value)}/>
            <div className="iio-field-hint">Empfohlen, wenn Access Policies im Einsatz sind - kann auch später nachgetragen werden.</div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
